import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../../../services";

@Component({
    selector: 'app-scene-block-fasterq',
    templateUrl: './block-fasterq.component.html',
    styleUrls: ['./block-fasterq.component.scss']
})
export class BlockFasterqComponent extends BlockBaseComponent {

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        super.initApplyStoreToDynamic(true);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.color', {}, this.translocoService.getActiveLang()),
                inputType: "color",
                name: "bgColor",
                storePath: 'Data[0].Webkit[0].Data[0].$.bgColor'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.line', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "lineID1",
                storePath: 'Data[0].Webkit[0].Data[0].$.lineID1'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.line', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "lineID2",
                storePath: 'Data[0].Webkit[0].Data[0].$.lineID2'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.line', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "lineID3",
                storePath: 'Data[0].Webkit[0].Data[0].$.lineID3'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.line', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "lineID4",
                storePath: 'Data[0].Webkit[0].Data[0].$.lineID4'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.line', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "lineID5",
                storePath: 'Data[0].Webkit[0].Data[0].$.lineID5'
            }
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
        ];
    }
}

